var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base_aggregator", {
        attrs: { provider_id: this.provider_id, provider_type: "shopify" },
        on: {
          edit_location: _vm.edit_location,
          get_json: _vm.get_json,
          show_menu: _vm.show_menu,
          make_sync: _vm.make_sync,
          add_location: _vm.add_location,
          head_action: _vm.head_action,
        },
      }),
      _vm._v(" "),
      _c("shopify_location_modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }